import { render, staticRenderFns } from "./TeamUniform.vue?vue&type=template&id=2c1a4db3"
import script from "./TeamUniform.vue?vue&type=script&lang=js"
export * from "./TeamUniform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports